module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/guests_ru_mobile-62d217c245ad0ef58533ebe603dcb50b.webp";